<template>
  <div
    v-if="value"
    class="price-info"
    :class="{
      'price-info--reduction': value.old,
      [`price-info--currency-${value.currency}`]: true
    }"
    :aria-label="$t('checkout.basket.position.header.price') + ' ' + value.current"
  >
    <div
      class="price-info__old"
      v-if="value.old"
    >
      <span class="price-info__old-text">{{ $t('price.instead_of') }}</span>
      <span class="price-info__old-value">{{ value.old }}</span>
    </div>

    <div class="price-info__current">
      <span class="price-info__currency">
        {{ value.currency }}
      </span>
      <span class="price-info__value">
        {{ value.currentValue }}
      </span>
      <sup
        v-if="showStar"
        class="price-info__asterisk"
      >
        *
      </sup>
    </div>

    <div class="price-info__unit">
      <span class="price-info__unit-text">
        {{ getUnitText() }}
      </span>
      <span
        v-if="value.unitPrice"
        class="price-info__unit-price"
      >
        {{ value.unitPrice }}<template v-if="value.unit">/{{ value.unit }}</template>
      </span>
    </div>

    <div
      v-if="showTax"
      class="price-info__tax"
      v-html="$t(showShippingIncluded ? messageKey.deliveryInclShip : messageKey.deliveryInclVat, [shippingInfoUrl])"
    />
  </div>
</template>

<script setup lang="ts">
  import {ref} from 'vue';
  import type Price from '../../types/Price';
  import {t} from '../../utilities/js/translations/translations';

  const props = withDefaults(defineProps<{
    value: Price;
    showStar?: boolean;
    showTax?: boolean;
    showShippingIncluded?: boolean;
    showSavedPercentage?: boolean;  // vinos only, not implemented in bps template
    shippingInfoUrl?: string;
    foodSpecificationLink?: string;
  }>(), {
    showStar: false,
    showTax: false,
    showShippingIncluded: false,
    showSavedPercentage: false,
    shippingInfoUrl: '',
    foodSpecificationLink: '',
  });

  const messageKey: {[key: string]: any} = ref({
    deliveryInclShip: 'price.incl_vat_incl_ship',
    deliveryInclVat: 'price.incl_vat',
  });

  if (window.__productConfig && window.__productConfig.messageKey) {
    messageKey.value = window.__productConfig.messageKey;
  }

  function getUnitText() {
    let result = t(`product.price.volumeUnit.${props.value.volumeUnit}`);
    if (props.value.unitPrice) {
      if (props.value.packageSize) {
        result += ' (' + props.value.packageSize + ')';
      }
      result += ',';
    }

    return result;
  }
</script>
